<template lang="pug">
    v-autocomplete(dense 
        v-model="dataMap" 
        :disabled="disabled"
        :readonly="readonly" 
        :label="label" 
        :rules="rules"
        :items="listData" 
        :item-text="text" 
        item-value="mapId" 
        @change="onSelect" 
        :required = "required")
</template>
<script>
export default {
    name: "FSelectMap",
    props: [
        "value",
        "disabled",
        "readonly",
        "label",
        "rules",
        "required",
        "mapData"
    ],
    data() {
        return {
            dataMap: {},
            listData: []
        }
    },
    mounted() {
        this.doLoad();
        this.doInit(this.value);
    },
    watch: {
        value(val){
            this.doInit(val);
        },
        mapData(val){
            this.listData = val || [];
        }
    },
    methods: {
        text: item => item.mapId + " - " + item.description,
        doInit(values){
            this.dataMap = values ? values : null;
            this.onSelect();
        },
        doLoad(){
            if (!this.mapData) {
                this.$http.get("/api/parameter/map-tax").then(success => {
                    this.listData = success.data;
                });
            }
        },
        onSelect() {
            this.$emit("input", this.dataMap);
            this.$emit("select", this.dataMap);
            this.$emit("map", this.valueData());
        },
        valueData(){
            let result = null;
            this.listData.map(element => {
                if (this.dataMap === element.mapId) {
                    result = element;
                }
            });
            return result;
        },
    },
}
</script>